import style from "./Botev.Module.css"
import { LangContext } from "../../contexts/Language";
import { useContext, useEffect } from "react";
import { CalendarBotev } from "../Calendar/Botev/CalendarBotev";
import { Carousel } from "../Carousel/Carousel";


export const Botev = ({ BotevPhotos }) => {
    const { lang } = useContext(LangContext);

    useEffect(() => {
        const titles = {
            BG: 'Апартамент Христо Ботев - Под наем в Созопол | Морска гледка',
            EN: 'Apartment Hristo Botev - For Rent in Sozopol | Sea View',
            RU: 'Апартамент Христо Ботев - Аренда в Созополе | Вид на море',
            CZ: 'Apartmán Hristo Botev - Pronájem v Sozopolu | Výhled na moře',
        };
        document.title = titles[lang] || titles.BG;
    }, [lang]);

    const gallery = <Carousel photos={BotevPhotos} />;

    if (lang === 'BG') {
        return (
            <section className="botev-photos">
                <h2 id="gallery">АПАРТАМЕНТ Христо Ботев - ГАЛЕРИЯ</h2>
                {gallery}
                <h2 id="map">Къде може да ни намерите</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d736.3573603865625!2d27.698564475629567!3d42.41859319355605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c75d8a6deda7%3A0x53c17e26e8158da1!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0KXRgNC40YHRgtC-INCR0L7RgtC10LIgLyBIcmlzdG8gQm90ZXYgYXBhcnRtZW50!5e0!3m2!1sbg!2sbg!4v1687796210571!5m2!1sbg!2sbg"
                    className="botev-map"
                    title="Botev map"
                />
                <h2 id="prices">Цени и удобства</h2>
                <section className="prices-botev">
                    <section className="price">
                        <div>
                            <h5>Септември - юни</h5>
                            <p>60 EUR</p>
                        </div>
                        <div>
                            <h5>Юли - август</h5>
                            <p>70 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Интернет<i className="fa-solid fa-wifi"></i></p>
                            <p>Телевизия<i className="fa-solid fa-tv"></i></p>
                            <p>Хладилник<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Климатик<i className="fa-solid fa-snowflake"></i></p>
                            <p>Котлони<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Посуда<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Заетост</h2>
                    <CalendarBotev />
                </div>
            </section>
        );
    };

    if (lang === 'EN') {
        return (
            <section className="botev-photos">
                <h2 id="gallery">APARTMENT HRISTO BOTEV - GALLERY</h2>
                {gallery}
                <h2 id="map">OUR ADDRESS</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d736.3573603865625!2d27.698564475629567!3d42.41859319355605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c75d8a6deda7%3A0x53c17e26e8158da1!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0KXRgNC40YHRgtC-INCR0L7RgtC10LIgLyBIcmlzdG8gQm90ZXYgYXBhcnRtZW50!5e0!3m2!1sbg!2sbg!4v1687796210571!5m2!1sbg!2sbg"
                    className="botev-map"
                    title="Botev map"
                />
                <h2 id="prices">Prices and comfort</h2>
                <section className="prices-botev">
                    <section className="price">
                        <div>
                            <h5>September - June</h5>
                            <p>60 EUR</p>
                        </div>
                        <div>
                            <h5>July - August</h5>
                            <p>70 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Internet<i className="fa-solid fa-wifi"></i></p>
                            <p>TV<i className="fa-solid fa-tv"></i></p>
                            <p>Refrigerator<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Air-conditioning<i className="fa-solid fa-snowflake"></i></p>
                            <p>Stove<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Utensils<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Occupancy</h2>
                    <CalendarBotev />
                </div>
            </section>
        );
    };

    if (lang === 'RU') {
        return (
            <section className="botev-photos">
                <h2 id="gallery">АПАРТАМЕНТ ХРИСТО БОТЕВ - ГАЛЕРЕЯ</h2>
                {gallery}
                <h2 id="map">Как нас найти</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d736.3573603865625!2d27.698564475629567!3d42.41859319355605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c75d8a6deda7%3A0x53c17e26e8158da1!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0KXRgNC40YHRgtC-INCR0L7RgtC10LIgLyBIcmlzdG8gQm90ZXYgYXBhcnRtZW50!5e0!3m2!1sbg!2sbg!4v1687796210571!5m2!1sbg!2sbg"
                    className="botev-map"
                    title="Botev map"
                />
                <h2 id="prices">Цены и удобства</h2>
                <section className="prices-botev">
                    <section className="price">
                        <div>
                            <h5>Сентябрь - июнь</h5>
                            <p>60 EUR</p>
                        </div>
                        <div>
                            <h5>Июль - август</h5>
                            <p>70 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Интернет<i className="fa-solid fa-wifi"></i></p>
                            <p>Телевизор<i className="fa-solid fa-tv"></i></p>
                            <p>Холодильник<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Кондиционер<i className="fa-solid fa-snowflake"></i></p>
                            <p>Плита<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Посуда<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Занятость</h2>
                    <CalendarBotev />
                </div>
            </section>
        );
    };

    if (lang === 'CZ') {
        return (
            <section className="botev-photos">
                <h2 id="gallery">APARTMÁN HRISTO BOTEV - GALERIE</h2>
                {gallery}
                <h2 id="map">Kde nás najdete</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d736.3573603865625!2d27.698564475629567!3d42.41859319355605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c75d8a6deda7%3A0x53c17e26e8158da1!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0KXRgNC40YHRgtC-INCR0L7RgtC10LIgLyBIcmlzdG8gQm90ZXYgYXBhcnRtZW50!5e0!3m2!1sbg!2sbg!4v1687796210571!5m2!1sbg!2sbg"
                    className="botev-map"
                    title="Botev map"
                />
                <h2 id="prices">Ceny a vybavení</h2>
                <section className="prices-botev">
                    <section className="price">
                        <div>
                            <h5>Září - červen</h5>
                            <p>60 EUR</p>
                        </div>
                        <div>
                            <h5>Červenec - srpen</h5>
                            <p>70 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Internet<i className="fa-solid fa-wifi"></i></p>
                            <p>Televize<i className="fa-solid fa-tv"></i></p>
                            <p>Lednice<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Klimatizace<i className="fa-solid fa-snowflake"></i></p>
                            <p>Vařič<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Nádobí<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Obsazenost</h2>
                    <CalendarBotev />
                </div>
            </section>
        );
    };
};
